import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { EffectsContainer } from 'mixins/withEffects';
import WCCAttachment from 'models/attachments/attachment';
import Transcript, { JSONTranscript } from 'models/transcript';
import './transcript.html';
import './transcript.scss';

const collapsedSize = 300;
const minSize = 350;

export interface AttachmentTranscriptionVMConfig {
    attachment: SubscribableOrNullableValue<WCCAttachment>
}

@injectable()
export default class AttachmentTranscriptVM {
    labels = labels;

    contentNode = ko.observable<HTMLElement>();
    isExpanded = ko.observable(false);

    text: Subscribable<string>

    isExpandSupported: Subscribable<boolean>    

    constructor(
        @inject(wccModules.componentConfig) config: AttachmentTranscriptionVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        const attachment = ko.flattenComputed(config.attachment);
        const transcriptContent = attachment.pluck(a => a.transcriptContent);
        const transcript = transcriptContent.pluck(content => new Transcript(<JSONTranscript>JSON.parse(content || '{}')));
        const text = transcript.pluck(transcript => transcript.text, '');

        const hasContent = text.is(text => text.length > 0);
        this.isExpandSupported = text.is(text => text.length > minSize);

        this.text = ko.pureComputed(() => {
            if (this.isExpandSupported() && !this.isExpanded())
                return text().substr(0, collapsedSize) + '...';

            return text();
        });

        effects.register(isExpandSupported => {
            if (!isExpandSupported)
                this.isExpanded(false);
        }, [this.isExpandSupported]);

        ko.applyBindingsToNode(info.element, {
            'visible': hasContent,

            'css': {
                'attachment-transcript': true
            }
        });
    }

    toggle = () => {
        this.isExpanded.toggle();
    }
}